
import { Component, Prop, Vue } from 'bits/vue'
import OzDrawerDraggable from 'library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from 'library/v4/components/OzDrawerStatic.vue'
import OzPopoverModal from 'library/v4/components/OzPopoverModal.vue'
/**
 * Screen size aware drawer modal that renders OzDrawer on phone and OzPopoverModal on desktop. Used in Content picker.
 */

@Component({ components: { OzDrawerStatic, OzDrawerDraggable, OzPopoverModal } })
export default class OzScreenSizeAwarePopoverModal extends Vue {
  @Prop({ default: false }) isPhone!: boolean
  @Prop({ default: false }) isDraggableDrawer!: boolean
}
